import Accordion from './accordion';

class MobileOnlyAccordion extends Accordion {
  initialize() {
    super.initialize();

    window.addEventListener('resize', () => {
      this.render(this.triggerEl);
    });

    this.render(this.triggerEl);
  }

  render(triggerEl) {
    if (window.innerWidth > 767) {
      if (triggerEl.getAttribute('aria-hidden') === 'false') {
        if (this.checkStatus(this.triggerEl) === 'false') {
          this.openAccordion(this.triggerEl);
        }
        this.hideAccordionToggle(triggerEl);
      } else {
        if (this.checkStatus(this.triggerEl) === 'false') {
          this.openAccordion(this.triggerEl);
        }
      }
    } else {
      if (triggerEl.getAttribute('aria-hidden') === 'true') {
        if (this.checkStatus(this.triggerEl) === 'true') {
          this.closeAccordion(this.triggerEl);
        }
        this.showAccordionToggle(triggerEl);
      }
    }
  }

  hideAccordionToggle(triggerEl) {
    triggerEl.setAttribute('aria-hidden', 'true');
  }

  showAccordionToggle(triggerEl) {
    triggerEl.setAttribute('aria-hidden', 'false');
  }
}

export default MobileOnlyAccordion;
